import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ApiAboutService } from "../Services/api-about.service";

@Injectable()
export class CanActivateIDUpload  {
    constructor(
        private router: Router,
        private aboutService: ApiAboutService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        if(this.aboutService.isIDVflow()) {
            return true;
        } else {
            return this.router.createUrlTree(environment.startRoute)
        } 
    }
}